import { JSX } from 'react'

import { GridWrapper } from '../../../../../../../components'
import Marker from '../../../../../../../components/Marker'
import { MedicalOffice } from '../../../../../../../infrastructure/dtos/Offices'

interface ILocationPanelMap {
  map: google.maps.Map | undefined
  offices: MedicalOffice[]
  selectedMarker: (officeId: string) => void
}

export default function LocationPanelMap({ map, offices, selectedMarker }: ILocationPanelMap): JSX.Element {
  const handleMarkerClick = (officeId: string): void => {
    selectedMarker(officeId)
  }

  return (
    <>
      {offices?.map((item) => {
        return (
          <Marker
            key={`officePosition-${item.office_id}`}
            map={map}
            position={{
              lat: Number(item.coordinates_medical_office.latitude),
              lng: Number(item.coordinates_medical_office.longitude),
            }}
            testId="patient-locate"
            onClick={() => handleMarkerClick(item.office_id)}
            children={
              <GridWrapper
                sx={{
                  width: 20,
                  height: 20,
                  backgroundColor: item.selected ? '#3850B2' : '#878787',
                  borderRadius: 50,
                }}
              />
            }
          />
        )
      })}
    </>
  )
}
